<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <img
          :srcset="srcset"
          :src="require('./assets/logo_netzebw.png')"
          width="167"
        />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!--<v-btn
        flat
        href="https://zenner-iot.com"
        target="_blank"
      >
        <span class="mr-2 hidden-md-and-down">by ZENNER IoT Solutions GmbH</span>
      </v-btn>-->
    </v-toolbar>

    <v-content>
      <DataPlanExporter/>
    </v-content>
  </v-app>
</template>

<script>
import DataPlanExporter from './components/DataPlanExporter'

export default {
  name: 'App',
  components: {
    DataPlanExporter
  },
  data () {
    return {
      srcset: require('./assets/logo_netzebw.svg') + ' 167w, ' + require('./assets/logo_netzebw.png') + ' 167w',
    }
  }
}
</script>
